import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import info from '../../../content/media-library/icons/info.svg';

const DEFAULT_WIDTH = 240;
const DEFAULT_PADDING = 20;

const ALIGNMENT = {
  LEFT: 'left',
  RIGHT: 'right',
  NONE: null
};

// Pleaes use the `id` prop when using this component

const Tooltip = ({ id, heading, bio, list, customText }) => {
  const [alignment, setAlignment] = useState(ALIGNMENT.NONE);
  const [width, setWidth] = useState(DEFAULT_WIDTH);
  const [display, setDisplay] = useState('');
  const buttonRef = useRef();

  const calculateTooltipPosition = () => {
    const { left, right, width: buttonWidth } = buttonRef.current.getBoundingClientRect();

    if (left + buttonWidth / 2 - DEFAULT_WIDTH / 2 - DEFAULT_PADDING < 0) {
      setAlignment(ALIGNMENT.LEFT);

      const newWidth = left + DEFAULT_WIDTH + DEFAULT_PADDING;
      if (newWidth > window.innerWidth) {
        setWidth(DEFAULT_WIDTH - (newWidth - window.innerWidth));
      }
    } else if (right - buttonWidth / 2 + DEFAULT_WIDTH / 2 + DEFAULT_PADDING > window.innerWidth) {
      setAlignment(ALIGNMENT.RIGHT);

      const newWidth = right - DEFAULT_WIDTH - DEFAULT_PADDING;
      if (newWidth < 0) {
        setWidth(DEFAULT_WIDTH + newWidth);
      }
    } else {
      setAlignment(ALIGNMENT.NONE);
      setWidth(DEFAULT_WIDTH);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', calculateTooltipPosition);

    return () => {
      window.removeEventListener('resize', calculateTooltipPosition);
    };
  }, []);

  const tooltipClass = classNames({
    [`tooltip--${alignment}-align`]: !!alignment
  });

  useEffect(() => {
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        setDisplay('tooltip__hide');
      } else {
        setDisplay(tooltipClass);
      }
    });
    window.addEventListener('mousemove', () => {
      setDisplay(tooltipClass);
    });
  }, [tooltipClass]);

  return (
    <div className="tooltip">
      <button
        aria-describedby={id}
        className="tooltip__button"
        onMouseOver={calculateTooltipPosition}
        onFocus={calculateTooltipPosition}
        ref={buttonRef}
      >
        <p className="screen-reader-text">More information about {heading}</p>
        {customText ? <span>{customText}</span> : <img alt="Information icon" src={info} />}
      </button>
      <div id={id} className={display} style={{ width }} role="tooltip">
        {bio && <p>{bio}</p>}
        {list && (
          <ol>
            {list.map((listItem) => (
              <li key={listItem}>{listItem}</li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  id: PropTypes.string,
  heading: PropTypes.string,
  bio: PropTypes.string,
  list: PropTypes.array,
  customText: PropTypes.string
};

export default Tooltip;
